<template>
  <div class='form-element-component'>
    <div class='label-element' v-if='inputVal.length' :style="{display: 'block'}" :class='{labelMultilines: multilines}'>{{ title }}</div>
    <input :name="name" v-validate="validate" class='input-element' v-if='inputMode == "input"' :type='type' :placeholder='placeholder' :autocomplete="autocomplete" :inputmode="inputmode" v-model='inputVal'>
    <textarea :style="{ height }" :name="name" v-validate="validate" class='textarea-element' v-if='multilines && (inputMode == "textarea")' :placeholder='placeholder' :autocomplete="autocomplete" v-model='inputVal'></textarea>
    <img class='logo-element' :class="{error: errors.first(name)}" :src='logo'/>
    <div class="error-container">
      <span>{{ errors.first(name) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormElementComponent',

  props: {
    name: String,
    validate: String,
    multilines: Boolean,
    update: Function,
    inputType: String,
    title: String,
    type: String,
    placeholder: String,
    value: String,
    logo: String,
    autocomplete: { type: String, default: 'on' },
    inputmode: { type: String, default: null }
  },

  data () {
    return {
      inputVal: this.value,
      inputMode: this.multilines ? 'textarea' : 'input'
    }
  },

  computed: {
    height () {
      const lines = this.inputVal.split('\n')
      let size = lines.length
      for (const line of lines) {
        if (line.length > 30) size += Math.ceil(line.length / 30) - 1
      }

      if (size > 6) size = 6
      return 24 * size + 'px'
    }
  },

  watch: {
    inputVal (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.update(this.inputType, this.inputVal)
      }
    },
    value (newValue, oldValue) {
      if (newValue === '') this.inputVal = ''
    }
  }
}
</script>

<style lang='scss' scoped>
.error-container {
  position: absolute;
  color: red;
  margin-top: 2px;
  text-align: left;

  font-size: 14px;
  font-weight: 400px;
  letter-spacing: 0;
}
  .form-element-component {
    position: relative;
    width: 100%;
    box-sizing: border-box;

    input {
      border: none;
      border-bottom: 1px solid #979797;
      display: block;
      font-size: 0.9rem;
      outline: none;

      border-radius: 0;
      font-weight: 300px;
      font-size: unset;

      transition: border-bottom .3s ease;

    }

    input:focus {
      border-bottom: 1px solid #B98A30;
    }

    textarea {
      resize: none;
      border: none;
      border-bottom: 1px solid #979797;
      display: block;
      font-size: 0.9rem;
      outline: none;
      width: calc(100% - 54px);
      padding-right: 54px;
      transition: border-bottom .3s ease;
      border-radius: 0px;

      font-size: 14px;
      line-height: 24px;
    }

    // textarea:focus {
    //   border-bottom: 1px solid #B98A30;
    // }

    img {
      padding-bottom: 10px;
      width: 40px;

      @include media (phone) {
        padding-bottom: 5px;
      }
    }

    .label-element {
      position: absolute;
      display: none;
      text-align: left;
      margin-bottom: 4px;

      top: -24px;

      font-size: 14px;

      font-weight: 400px;
      letter-spacing: 0;

      @include media (phone) {
        font-size: 0.8rem;
        bottom: 24px;
      }
    }

    .input-element {
      padding-bottom: 5px;
      width: calc(100% - 54px);
      padding-right: 54px;

      font-size: 14px;
    }

    .logo-element {
      bottom: 2px;
      position: absolute;
      right: 2px;
      width: 32px;

      user-select: none;

      &.error {
        bottom: 20px;
      }

      @include media (phone) {
        bottom: 1px;
        width: 30px;
      }
    }
  }
</style>
